import React from "react";
import { Button } from "antd";
import SVGIcon from "../../../utils/SVGIcon";
import { ButtonProps } from "../../Buttons/interface/ButtonInterface";
import { useAppSelector } from "../../../utils/hooks/hooks";

const EditButton: React.FC<Partial<ButtonProps>> = ({
  action,
  data,
  permission,
  ...rest
}) => {

  const [loading,id] =useAppSelector((state)=>state.common.editLoading)
  if (!permission) {
    return null;
  }

  delete rest?.permissionKey;
  
  return (
    <Button
      type="text"
      title={"Edit"}
      className="editIcon"
      loading={loading&&(data.id===id)&&loading}
      onClick={() => action && action(data)}
      {...rest}
    >
     {loading&&(data.id===id)?"":<SVGIcon icon="edit" />}
    </Button>
  );
};

export default EditButton;
